import React from 'react';
import { Box, InlineStack, BlockStack, Text, Button, Tag, Tooltip } from '@shopify/polaris';
import Placeholder from '../common/Placeholder';

const ChooseSection = ({
    selectedIds,
    handleModalOpen,
    handleIdRemove,
    title,
    titleHelp,
    createButtonText,
    modalType
}) => {
    return (
        <Box>
            <InlineStack align='space-between' blockAlign='center'>
                <BlockStack gap='100'>
                    <Text variant="headingSm" as="span">
                        {title}
                    </Text>
                    {titleHelp?.length >= 112 &&
                        <Tooltip content={titleHelp}>
                            <Text variant='bodySm' tone='subdued'>
                                {titleHelp?.length > 112 ? titleHelp?.slice(0, 112) + '...' : titleHelp}
                            </Text>
                        </Tooltip>
                    }
                </BlockStack>
                <Button
                    variant='primary'
                    onClick={() => handleModalOpen(modalType)}
                >
                    {createButtonText}
                </Button>
            </InlineStack>
            {selectedIds?.length > 0 && <Placeholder padding='5px var(--p-space-100)' height='2px'/>}
            {selectedIds?.length > 0 &&
                <InlineStack gap='200'>
                    {selectedIds?.map((option) => (
                        <Tag onRemove={() => handleIdRemove(option)}>
                            {option?.split('/').pop()}
                        </Tag>
                    ))}
                </InlineStack>
            }
        </Box>
    );
};

export default ChooseSection;